(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('announcement-riders')) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    class AnnouncementRiders extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.announcement__track');
        this.slides = Array.from(this.querySelectorAll('.announcement__slide'));
        this.count = this.slides.length - 1; /* the last slide repeats the first */
        if (this.count < 2) return;
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 5000;
        this.paused = false;
        this.addEventListener('mouseenter', () => (this.paused = true));
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));
        this.track.addEventListener('transitionend', (event) => {
          if (event.target === this.track) this.settle();
        });
        this.onResize = () => this.place(false);
        window.addEventListener('resize', this.onResize);
        this.onVisibility = () => { if (!document.hidden) this.schedule(); };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.advance(), this.interval);
      }

      /* distance from one message to the next: one slide plus the riders */
      step() {
        const rider = this.querySelector('.announcement__rider-slot');
        return this.slides[0].offsetWidth + (rider ? rider.offsetWidth : 0);
      }

      place(animate) {
        const distance = this.index * this.step();
        this.track.classList.toggle('is-moving', animate && !reduced.matches);
        if (animate && !reduced.matches) {
          /* about 700px per second, between 1.4 and 3 seconds */
          const duration = Math.round(Math.min(Math.max(this.step() / 0.7, 1400), 3000));
          this.track.style.setProperty('--slide-duration', `${duration}ms`);
        }
        this.track.style.transform = `translateX(${distance}px)`;
      }

      advance() {
        if (document.hidden) return;
        /* a hovered bar or an open popup waits */
        if (this.paused || document.querySelector('dialog[open]')) return this.schedule();
        this.index += 1;
        this.place(true);
        if (reduced.matches) this.settle();
      }

      settle() {
        this.track.classList.remove('is-moving');
        if (this.index >= this.count) {
          /* back to the real first message, which looks exactly like the copy */
          this.index = 0;
          this.place(false);
        }
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          if (i < this.count) {
            slide.toggleAttribute('inert', !active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          }
        });
        this.schedule();
      }
    }
    customElements.define('announcement-riders', AnnouncementRiders);

    /* continuous strip: the duration follows the length, so the speed (pixels per second) stays the same */
    if (!customElements.get('announcement-marquee')) {
      class AnnouncementMarquee extends HTMLElement {
        connectedCallback() {
          this.group = this.querySelector('.announcement__marquee-group');
          this.update = () => {
            const speed = Number(this.dataset.speed) || 40;
            const width = this.group ? this.group.offsetWidth : 0;
            if (width) this.style.setProperty('--marquee-duration', (width / speed).toFixed(1) + 's');
          };
          this.update();
          window.addEventListener('resize', this.update);
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.update);
        }
        disconnectedCallback() { window.removeEventListener('resize', this.update); }
      }
      customElements.define('announcement-marquee', AnnouncementMarquee);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
